import React, {Component} from "react";
import {injectIntl} from "react-intl";

class Desk extends Component {

  onDeskSelect = () => {
    const {selected, onSelect, selectable} = this.props;
    if (!selected && onSelect && selectable) {
      onSelect();
    }
  };

  render() {
    const {intl: {formatMessage}, selected} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    return (
      <div>
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.onDeskSelect}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id:'appointment.detail.reception.desk.title'})}</h4>
          </header>
          <div className="choice-card__body">
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(Desk)
